import React from "react";
import InfoAccordion from "./InfoAccordion";
import DetailField from "./DetailField";

export default function StoreInformation({ singleOrder }) {
  return (
    <InfoAccordion
      parentId="accordionStore"
      itemId="accordion-item-icon-right-2"
      title="Store Information"
    >
      <div className="order_contact">
        <div className="d-flex">
          <div className="mr-4">
            <div className="alternative-image">
              {singleOrder?.outlet_name?.charAt(0)}
            </div>
          </div>
          <div className="px-2 w-100">
            <div className="row">
              <DetailField
                label="Store name:"
                value={singleOrder.outlet_name}
                valueClassName="text-capitalize"
              />
              <DetailField
                label="Store phone:"
                value={singleOrder.outlet_phone}
              />
              <DetailField
                label="Store Address:"
                value={singleOrder.outlet_address}
              />
            </div>
          </div>
        </div>
      </div>
    </InfoAccordion>
  );
}
